<template>
  <svg class="timeline-separator" xmlns="http://www.w3.org/2000/svg" version="1.1">
    <rect x="9" y="0" width="2" height="100%"/>
  </svg>
</template>

<script>
export default {
};
</script>

<style>
.timeline-separator {
  display: flex;
  flex-direction: row;
  position: relative;
  height: 30px;
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// TimelineSeparator.vue?027ac038